import axios from "axios";

import { getBaseURL } from "@vega-core/utils/global";

const axiosConfig = {
  baseURL: getBaseURL(),
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 60_000,
  paramsSerializer: { indexes: null },
};

export const cleanAxiosInstance = axios.create(axiosConfig);
